angular.module 'zc.core'

.constant 'cronHours',
  dailyReport: 5



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/constants/cron_hours.coffee